import React, {useRef, useEffect} from 'react';
import {connect} from 'react-redux';
import SMCPageLoading from '../../components/core/pageComponents/SMCPageLoading';
import Api from '../../api/SMPFetchHelper';
import {push} from 'connected-react-router';
import {setUserId, setCurrentPortal, setUserRole, setPortalTimeZone, setAvailablePortals, setAvailablePlans, resetUser, setIsCyberViewsEnabled, setIsSMELogsEnabled} from '../../store/actions/user.actions';
import {SessionDataGetSchema} from '../../api/DBSchema/SessionData';
import {SMCPaths} from '../../conf/Routes';
import {isEmptyDomain} from '../../utils/utils';
import {isEmptyPortalSelector} from '../../store/selectors/user.selectors';

function ReloginHandler({
    pageData,
    navigateTo,
    setUserId,
    setCurrentPortal,
    setUserRole,
    setPortalTimeZone,
    setAvailablePortals,
    setAvailablePlans,
    setIsCyberViewsEnabled,
    setIsSMELogsEnabled,
    resetUser,
    isEmptyPortalBeforeRelogin
}) {
    const isFirstReq = useRef(true);

    useEffect(() => {
        (async () => {
            if (isFirstReq.current && pageData && pageData.domainName) {
                isFirstReq.current = false;

                // If given no domain name on page data, direct to system settings or home on current domain
                if (!pageData || !pageData.domainName) {
                    if (isEmptyPortalBeforeRelogin) {
                        navigateTo(SMCPaths.systemSettings);
                    } else {
                        navigateTo(SMCPaths.home); // Home only exists on non-empty domain (meanwhile...)
                    }
                }
                // Given domain name, change portal and direct to system settings or home on new domain
                else {
                    try {
                        await Api.changePortal(pageData.domainName);
                        resetUser();
                        /* Get session data */
                        const sessionDataResp = await Api.getSessionData({attributes: [
                            SessionDataGetSchema.userId,
                            SessionDataGetSchema.portalName,
                            SessionDataGetSchema.userRole,
                            SessionDataGetSchema.serviceCenterTimeZone,
                            SessionDataGetSchema.availablePortals,
                            SessionDataGetSchema.availablePlans,
                            SessionDataGetSchema.isCyberViewsEnabled,
                            SessionDataGetSchema.isSMELogsEnabled
                        ]});
                        const sessionData = sessionDataResp.data;
                        setUserId(sessionData[SessionDataGetSchema.userId]);
                        setCurrentPortal(
                            sessionData[SessionDataGetSchema.portalName] ? 
                            sessionData[SessionDataGetSchema.portalName].toLowerCase() :
                            sessionData[SessionDataGetSchema.portalName]
                        );
                        setUserRole(sessionData[SessionDataGetSchema.userRole]);
                        setPortalTimeZone(sessionData[SessionDataGetSchema.serviceCenterTimeZone]);
                        setAvailablePortals(sessionData[SessionDataGetSchema.availablePortals]);
                        setAvailablePlans(sessionData[SessionDataGetSchema.availablePlans]);
                        setIsCyberViewsEnabled(sessionData[SessionDataGetSchema.isCyberViewsEnabled]);
                        setIsSMELogsEnabled(sessionData[SessionDataGetSchema.isSMELogsEnabled]);
                        /* Finish login */
                        if (isEmptyDomain(sessionData[SessionDataGetSchema.portalName])) {
                            navigateTo(SMCPaths.systemSettings);
                        } else {
                            if (pageData.nextPage)
                                navigateTo(pageData.nextPage)
                            else
                                navigateTo(SMCPaths.home); // Home only exists on non-empty domain (meanwhile...)
                        }
                    } catch (e) {
                        console.error('Error changing domain, loging out', e);
                        navigateTo(SMCPaths.logout);
                    }
                }
            }
        })()
    }, [navigateTo, pageData, resetUser, setAvailablePlans, setAvailablePortals, setCurrentPortal, setUserId,  setPortalTimeZone, setUserRole, setIsCyberViewsEnabled, setIsSMELogsEnabled, isEmptyPortalBeforeRelogin]);

    return (
        <SMCPageLoading />
    );
}

const mapStateToProps = state => ({
    pageData: state.router.location.state,
    isEmptyPortalBeforeRelogin: isEmptyPortalSelector(state)
});

const mapDispatchToProps = {
    navigateTo: push,
    setUserId,
    setCurrentPortal,
    setUserRole,
    setPortalTimeZone,
    setAvailablePortals,
    setAvailablePlans,
    setIsCyberViewsEnabled,
    setIsSMELogsEnabled,
    resetUser
}

export default connect(mapStateToProps, mapDispatchToProps)(ReloginHandler);